import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/cube.svg
 */
const IconCube: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M20.983 5.62l-7.966-4.585a2.07 2.07 0 00-2.034 0L3.018 5.62A2.025 2.025 0 002 7.392v9.198a2.099 2.099 0 001.018 1.772l7.965 4.585a1.958 1.958 0 002.034 0l7.966-4.607A2.029 2.029 0 0022 16.565V7.392a2.07 2.07 0 00-1.017-1.771zm-9.197-3.19A.371.371 0 0112 2.38a.789.789 0 01.213.05l7.349 4.256-7.562 4.35-7.564-4.35 7.349-4.257zm-7.94 14.514a.447.447 0 01-.215-.368V8.069l7.567 4.372v8.723l-7.352-4.22zm16.308 0l-7.35 4.255V12.45l7.565-4.371v8.485a.42.42 0 01-.215.376v.003z"
      fill="currentColor"
    />
  </svg>
);

export default IconCube;
